export default [{
  path: '/mine/forgetPassword',
  name: 'forgetPassword',
  meta: {
    index: 14
  },
  component: () => import('@/views/mine/forgetPassword.vue')
}]
